/**
 * 资源 key 集中管理（Neon Candy Fortune — candy/ 新素材包）
 *
 * 与 src/game/assets/assetManifest.ts 一一对应。业务代码只引用此处的命名常量，
 * 改文件名 → 改 manifest → 这里跟着改名字即可。
 *
 * 旧的 NC-001..NC-120 命名已废弃；当前生效的资源在
 * `packages/phasergame/public/assets/candy/`。
 */

export const AssetKeys = {
  // ─── Symbols (cluster_tumble 12 张) ──────────────────
  symbol: {
    cherry:           'sym_cherry',
    lemon:            'sym_lemon',
    grape:            'sym_grape',
    watermelon:       'sym_watermelon',
    strawberry:       'sym_strawberry',
    blueberry:        'sym_blueberry',
    rainbow:          'sym_rainbow',
    heart_gummy:      'sym_heart_gummy',
    chocolate_square: 'sym_chocolate_square',
    star_candy:       'sym_star_candy',
    lollipop_scatter: 'sym_lollipop_scatter',
    multiplier_orb:   'sym_multiplier_orb',
  },

  // ─── Frame ───────────────────────────────────────────
  frame: {
    grid_6x5:  'frame_grid_6x5',
  },

  // ─── Backgrounds ─────────────────────────────────────
  bg: {
    main:        'bg_main',
    free_spins:  'bg_free_spins',
    loading:     'bg_loading',
  },

  // ─── Overlays ────────────────────────────────────────
  overlay: {
    big_win:          'overlay_big_win',
    win_celebration:  'overlay_win_celebration_generated',
    jackpot_generated:    'overlay_jackpot_generated',
    free_spins_generated: 'overlay_free_spins_generated',
  },

  // ─── Buttons (spin set + capsules) ───────────────────
  btn: {
    spin_idle:        'btn_spin_idle',
    spin_pressed:     'btn_spin_pressed',
    spin_disabled:    'btn_spin_disabled',
    stop:             'btn_stop',
    spin_base_notext: 'btn_spin_base_notext',
    spin_glow_pink:   'fx_spin_glow_pink',
    spin_glow_gold:   'fx_spin_glow_gold',
    claim:            'btn_claim',
    ok:               'btn_ok',
    capsule_purple:   'btn_capsule_purple',
  },

  // ─── UI shells ───────────────────────────────────────
  ui: {
    bg_decoration:    'ui_bg_decoration',
    grid_frame_alt:   'ui_grid_frame_alt',
    panel_purple_sq:  'ui_panel_purple_sq',
    pillar_purple:    'ui_pillar_purple',
    balance_pill:     'ui_balance_pill',
    bet_pill:         'ui_bet_pill',
    feature_strip:    'ui_feature_strip',
    ribbon_banner:    'ui_ribbon_banner',
    icon_back:        'ui_icon_back',
    icon_settings:    'ui_icon_settings',
    icon_info:        'ui_icon_info',
    icon_close:       'ui_icon_close',
    panel_white_pink: 'ui_panel_white_pink',
    panel_pink_frame: 'ui_panel_pink_frame',
    gen_jackpot_grand_wide: 'ui_gen_jackpot_grand_wide',
    gen_balance_pill:       'ui_gen_balance_pill',
    gen_balance_pill_wide:  'ui_gen_balance_pill_wide',
    gen_win_pill:           'ui_gen_win_pill',
    gen_total_bet_pill:     'ui_gen_total_bet_pill',
    gen_spin_button:        'ui_gen_spin_button',
  },

  // ─── FX ──────────────────────────────────────────────
  fx: {
    cell_outline:        'fx_cell_outline',
    cluster_link_h:      'fx_cluster_link_h',
    cluster_link_corner: 'fx_cluster_link_corner',
    cascade_streak:      'fx_cascade_streak',
    burst_icons:         'fx_burst_icons',
    heart_particles:     'fx_heart_particles',
    star_yellow:         'fx_star_yellow',
    sparkles:            'fx_sparkles',
    pink_puff:           'fx_pink_puff',
    falling_streak:      'fx_falling_streak',
    candy_bomb:          'fx_candy_bomb',
    landing_trail:       'fx_landing_trail',
    starburst_yellow:    'fx_starburst_yellow',
    starburst_pink:      'fx_starburst_pink',
    candy_swirl:         'fx_candy_swirl',
  },

  // ─── Free Spins ──────────────────────────────────────
  fs: {
    title:               'fs_title',
    banner_purple_top:   'fs_banner_purple_top',
    banner_horizontal:   'fs_banner_horizontal',
    panel_purple_left:   'fs_panel_purple_left',
    panel_cream_left:    'fs_panel_cream_left',
    btn_ok:              'fs_btn_ok',
    btn_pink_pill:       'fs_btn_pink_pill',
    swirl_bg:            'fs_swirl_bg',
    lollipop_left:       'fs_lollipop_left',
    lollipop_right:      'fs_lollipop_right',
    light_burst:         'fs_light_burst',
    candy_drop:          'fs_candy_drop',
    ribbon_decor:        'fs_ribbon_decor',
  },

  // ─── Win celebration ─────────────────────────────────
  win: {
    big_title:           'win_big_win_title',
    mega_title:          'win_mega_win_title',
    super_title:         'win_super_win_title',
    jackpot_title:       'win_jackpot_title',
    gold_frame:          'win_gold_frame',
    pink_frame:          'win_pink_frame',
    gold_coins:          'win_gold_coins',
    pink_candy_burst:    'win_pink_candy_burst',
    starburst_yellow:    'win_starburst_yellow',
    starburst_pink:      'win_starburst_pink',
    confetti:            'win_confetti',
    btn_ok_pink:         'win_btn_ok_pink',
    btn_pink_notext:     'win_btn_pink_notext',
    btn_purple_circle:   'win_btn_purple_circle',
    btn_pink_ring:       'win_btn_pink_ring',
    gen_title_big:       'win_title_big_win_generated',
    gen_title_mega:      'win_title_mega_win_generated',
    gen_title_super:     'win_title_super_win_generated',
    gen_title_jackpot:   'win_title_jackpot_generated',
    gen_title_free_spins:'win_title_free_spins_generated',
    gen_amount_frame:    'win_amount_frame_generated',
    gen_fs_count_frame:  'win_free_spins_count_frame_generated',
    gen_badge_big:       'win_badge_big_generated',
    gen_badge_mega:      'win_badge_mega_generated',
    gen_badge_super:     'win_badge_super_generated',
    gen_badge_jackpot:   'win_badge_jackpot_generated',
  },

  // ─── Audio (9 BGM + 17 SFX) ──────────────────────────
  audio: {
    bgm_main:               'bgm_main',
    bgm_free_spins:         'bgm_free_spins',
    bgm_big_win_stinger:    'bgm_big_win_stinger',
    bgm_mega_win_stinger:   'bgm_mega_win_stinger',
    bgm_loading:            'bgm_loading',
    // Lucky Fever room state + win-tier stingers (Suno batch 2026-05-06)
    bgm_lucky_fever_loop:   'bgm_lucky_fever_loop',
    bgm_fever_settlement:   'bgm_fever_settlement',
    bgm_super_win_stinger:  'bgm_super_win_stinger',
    bgm_jackpot_stinger:    'bgm_jackpot_stinger',
    sfx_spin_tap:           'sfx_spin_tap',
    sfx_reels_start:        'sfx_reels_start',
    sfx_reel_stop:          'sfx_reel_stop',
    sfx_cluster_detected:   'sfx_cluster_detected',
    sfx_candy_tumble:       'sfx_candy_tumble',
    sfx_symbol_burst:       'sfx_symbol_burst',
    sfx_multiplier_appears: 'sfx_multiplier_appears',
    sfx_multiplier_fly_in:  'sfx_multiplier_fly_in',
    sfx_small_win:          'sfx_small_win',
    sfx_big_win_count:      'sfx_big_win_count',
    sfx_free_spins_trigger: 'sfx_free_spins_trigger',
    sfx_free_spin_start:    'sfx_free_spin_start',
    sfx_bonus_summary:      'sfx_bonus_summary',
    sfx_error_soft:         'sfx_error_soft',
    sfx_button_disabled:    'sfx_button_disabled',
    sfx_fever_ignite:               'sfx_fever_ignite',
    sfx_fever_anticipation_pulse:   'sfx_fever_anticipation_pulse',
  },
} as const
